import styled from 'styled-components';
import type {DashboardTicketProject} from '../types/dashboardTicket';

const Dot = styled.span<{$color: string}>`
	flex-shrink: 0;
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background: ${p => p.$color};
`;

interface Props {
	project: DashboardTicketProject | null;
}

/**
 * The colour of a ticket's project, for the Project column's icon slot.
 *
 * A dot rather than the coloured chip PRD §8.1 draws: the design system's table
 * renders a column's text from its accessor and its icon *beside* that text, so a
 * chip carrying the project's name would print the name twice. The dot carries the
 * colour — the part a name can't — and the cell's text carries the name.
 *
 * Renders nothing when the ticket has no project, or a project with no colour: the
 * cell's text is already an em-dash, and a colourless dot would read as a project
 * whose colour is black.
 */
export function ProjectColorDot({project}: Props) {
	if (!project?.color) return null;
	return <Dot $color={project.color} data-testid="project-color-dot" data-project-id={project.id} />;
}
